import { command, state } from 'ccstate'
import { authClient } from '../../backendApi/authClient'

export const error$ = state('')
export const successMessage$ = state('')
export const email$ = state('')
export const password$ = state('')
export const isSignUp$ = state(false)
export const isSubmitting$ = state(false)

export const onSubmit$ = command(async ({ get, set }) => {
  set(error$, '')
  set(successMessage$, '')
  set(isSubmitting$, true)
  const isSignUp = get(isSignUp$)
  const email = get(email$)
  const password = get(password$)
  try {
    if (isSignUp) {
      await authClient.signUp({ email, password })
    } else {
      await authClient.signInWithPassword({ email, password })
    }
    if (isSignUp) {
      set(successMessage$, 'Please check your email to confirm your account')
      set(isSignUp$, false)
    }
  } catch (err) {
    set(error$, 'An unexpected error occurred:' + err)
  } finally {
    set(isSubmitting$, false)
  }
})